export default __webpack_public_path__ + "static/media/MariaDB-WindowsTaskScheduler-TriggerDailyTimeSetting03.770f18de.png";